import jQuery from 'jquery';
import Mousetrap from 'mousetrap';
import EventService from '../../common/event/EventService';
import PortalEvent from '../events/PortalEvent';
import VcomProvider from '../../VcomProvider';
import WindowProvider from '../../common/window/WindowProvider';
import AlertService from '../../common/alert/AlertService';
import translate from '../../common/localization/translate';
import { canCreate, canDelete } from '../../common/acl/AclService';
import AclModule from '../../common/acl/const/AclModule';
import CmmsAccessService from '../../cmms/access/service/AccessService';
import TicketCreateService from '../../ticketing/ticket/TicketCreateService';

function openControlRoom() {
  WindowProvider.location.href = VcomProvider.baseUrl;
}

function openCalendar() {
  WindowProvider.location.href = `${VcomProvider.baseUrl}/calendar`;
}

function openReporting() {
  WindowProvider.location.href = `${VcomProvider.baseUrl}/reporting`;
}

function selectNextSystem() {
  const systemList = jQuery('#sidebar .system-list').children();
  const activeRow = jQuery('#sidebar .activeRow');

  if (activeRow.next().length === 1) {
    activeRow.next().trigger('click');
  } else {
    systemList.first().trigger('click');
  }
}

function selectPreviousSystem() {
  const systemList = jQuery('#sidebar .system-list').children();
  const activeRow = jQuery('#sidebar .activeRow');

  if (activeRow.prev().length === 1) {
    activeRow.prev().trigger('click');
  } else {
    systemList.last().trigger('click');
  }
}

function openJumpToModal() {
  EventService.dispatch('openJumpToModal');
}

function openAnalysis() {
  WindowProvider.location.href = `${VcomProvider.baseUrl}/analysis`;
}

function switchChartsToCurrentDay() {
  const utc = new Date().toJSON().slice(0, 10);
  jQuery('.chartDateSelector input').val(utc);
  EventService.dispatch(PortalEvent.DATEPICKERS_CHANGED_TO_TODAY);
}

function switchChartsToPreviousPeriod() {
  jQuery('.chartDateSelector').find('.icon-arrow-left2').trigger('click');
}

function switchChartsToNextPeriod() {
  jQuery('.chartDateSelector').find('.icon-arrow-right2').trigger('click');
}

function openAdministration() {
  jQuery('#administration-control').trigger('click');
}

function openHelp() {
  document.getElementById('shortcuts').click();
}

function toggleSidebar() {
  jQuery('#sidebar-toggle').trigger('click');
}

async function deleteTicket() {
  const selectedTicketId = jQuery('.dataTables_scrollBody .ticketOverviewTable .active').attr('id');
  if (selectedTicketId === undefined) {
    return;
  }

  const isAlarm = selectedTicketId.startsWith('A');
  if (isAlarm) {
    const canDeleteAlarms = await canDelete(AclModule.MONITORING);
    if (canDeleteAlarms === false) {
      return;
    }

    const { default: TicketOverview } = await import('../../portlet/ticketOverview/TicketOverview');
    const ticketOverview = new TicketOverview();
    ticketOverview.deleteTicket(selectedTicketId);
    return;
  }

  const canDeleteTickets = await canDelete(AclModule.TICKETING);
  if (canDeleteTickets === false) {
    return;
  }

  const ticketOverviewTable = jQuery('.dataTables_scrollBody .ticketOverviewTable').DataTable();
  const selectedRowData = ticketOverviewTable.row(`#${selectedTicketId}`).data();
  EventService.dispatch('openTicketDeleteModal', {
    data: {
      tickets: [{
        ticketId: selectedTicketId,
        ticketTitle: selectedRowData.label,
      }],
    },
  });
}

function toggleDistractionFreeMode() {
  if (localStorage.getItem('distractionFreeMode') === 'true') {
    localStorage.setItem('distractionFreeMode', 'false');
    AlertService.showInfo(translate('shortcuts.DEACTIVATED_DISTRACTION_FREE_MODE'));
  } else {
    localStorage.setItem('distractionFreeMode', 'true');
    AlertService.showInfo(translate('shortcuts.ACTIVATED_DISTRACTION_FREE_MODE'));
  }
  EventService.dispatch(PortalEvent.DISTRACTION_FREE_MODE_CHANGED);
}

async function openNewTicketModal() {
  const hasAccess = await canCreate(AclModule.TICKETING);
  if (hasAccess === false) {
    return;
  }

  const systems = await TicketCreateService.getSystems();
  await TicketCreateService.openTicketCreateModal(systems);
}

async function openNewWorkOrderModal() {
  const hasCmms = await CmmsAccessService.hasCmms();
  if (hasCmms === true) {
    const workOrderCreateModalEvent = new CustomEvent('workOrderCreate');
    document.dispatchEvent(workOrderCreateModalEvent);
  }
}

function isNoModalOpen() {
  const administrationModal = document.getElementById('administration-modal');
  const isAdministrationModalOpen = administrationModal !== null && administrationModal.classList.contains('show');
  return !document.body.classList.contains('modal-open') && !isAdministrationModalOpen;
}

function callIfNoModalOpen(callback) {
  if (isNoModalOpen()) {
    callback();
  }
}

export default function addDefaultShortcuts() {
  Mousetrap.bind('h', () => callIfNoModalOpen(openControlRoom));
  Mousetrap.bind('c', () => callIfNoModalOpen(openCalendar));
  Mousetrap.bind('r', () => callIfNoModalOpen(openReporting));
  Mousetrap.bind('f', () => callIfNoModalOpen(selectNextSystem));
  Mousetrap.bind('b', () => callIfNoModalOpen(selectPreviousSystem));
  Mousetrap.bind('j', () => callIfNoModalOpen(openJumpToModal));
  Mousetrap.bind('a', () => callIfNoModalOpen(openAnalysis));
  Mousetrap.bind('t', () => callIfNoModalOpen(switchChartsToCurrentDay));
  Mousetrap.bind('p', () => callIfNoModalOpen(switchChartsToPreviousPeriod));
  Mousetrap.bind('n', () => callIfNoModalOpen(switchChartsToNextPeriod));
  Mousetrap.bind('s', () => callIfNoModalOpen(openAdministration));
  Mousetrap.bind('?', () => callIfNoModalOpen(openHelp));
  Mousetrap.bind('l', () => callIfNoModalOpen(toggleSidebar));
  Mousetrap.bind('del', () => callIfNoModalOpen(deleteTicket));
  Mousetrap.bind('d', () => callIfNoModalOpen(toggleDistractionFreeMode));
  Mousetrap.bind('shift+t', () => callIfNoModalOpen(openNewTicketModal));
  Mousetrap.bind('shift+w', () => callIfNoModalOpen(openNewWorkOrderModal));
}
